import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import AdminNavigationPane from './AdminNavigationPane';
import { colors } from '../colors';
import Layout from './Layout';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';

const AdminPageLayout = ({ views, defaultView, title }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const [currentComponent, setCurrentComponent] = useState(defaultView);

    useEffect(() => {
        const stateView = location.state?.view;
        if (stateView && views[stateView]) {
            setCurrentComponent(stateView);
        }
    }, [location.state, views]);
    

    const handleNavigation = (path) => {
        // Update state and navigate to maintain history
        setCurrentComponent(path);
        navigate('/admin/dashboard', { state: { view: path } });
    };

    const renderComponent = () => views[currentComponent] || views[defaultView];

    return (
        <Layout>
            {/* Blue Banner */}
            <Box
                sx={{
                    backgroundColor: colors.primaryBannerBlue,
                    color: 'white',
                    padding: { xs: '5px 0', sm: '10px 0' },
                    textAlign: 'center',
                    fontSize: { xs: '1rem', sm: '1.2rem' },
                    fontWeight: '500',
                }}
            >
                {title.toUpperCase()}
            </Box>

            <motion.div initial="initial" animate="animate" transition={{ duration: 1 }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        width: '100%',
                        minHeight: '100vh',
                        backgroundColor: '#eaecee',
                        padding: { xs: '10px', sm: '20px', md: '20px' },
                        boxSizing: 'border-box',
                        gap: { xs: 2, sm: 3 },
                    }}
                >
                    {/* Navigation Pane */}
                    <AdminNavigationPane
                        currentPath={currentComponent}
                        onNavigate={handleNavigation}
                    />

                    {/* Render Components Dynamically */}
                    <Box
                        sx={{
                            flexGrow: 1,
                            padding: '20px',
                            backgroundColor: 'white',
                            borderRadius: '20px',
                            boxShadow: '0 6px 14px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        {renderComponent()}
                    </Box>
                </Box>
            </motion.div>
        </Layout>
    );
};

export default AdminPageLayout;
